import { Text } from '@/components/common';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ModalButton, Wrapper, WrapperText } from './styled';

const CheckYourInboxModal: React.FC<any> = ({ closeModal, email }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    closeModal();
  };

  return (
    <Wrapper>
      <WrapperText>
        <Text
          color="primary"
          variant="titleModal"
          style={{ margin: '0px auto 16px auto', maxWidth: '250', width: '100%', textAlign: 'center', textTransform: 'uppercase' }}
        >
          {t('CHECK_YOUR_INBOX')}
        </Text>
        <Text color="secondary" variant="content" size="15">
          <Trans
            i18nKey="CHECK_YOUR_INBOX_CONTENT"
            values={{ email }}
            components={{
              email: <span className="fs-mask" />,
            }}
          />
        </Text>
      </WrapperText>
      <ModalButton variant="contained" color="dark" onClick={handleClose}>
        {t('CLOSE')}
      </ModalButton>
    </Wrapper>
  );
};

export default CheckYourInboxModal;
